import { Component, type ReactNode } from 'react'
import i18n from '@/lib/i18n'
import { captureException } from '@/lib/observability'

interface Props {
  children: ReactNode
}
interface State {
  hasError: boolean
}

/** Top-level error boundary — catches render errors, reports them, offers reload. */
export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false }

  static getDerivedStateFromError(): State {
    return { hasError: true }
  }

  componentDidCatch(error: unknown, info: { componentStack?: string | null }) {
    captureException(error, { componentStack: info.componentStack ?? undefined })
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen flex-col items-center justify-center gap-4 p-6 text-center">
          <div className="font-heading text-3xl font-bold">
            <span className="text-primary">bitu</span>
            <span className="text-travel">travel</span>
          </div>
          <p className="text-muted-foreground">{i18n.t('error.boundaryDesc')}</p>
          <button
            className="rounded-full bg-primary px-5 py-2 text-sm font-semibold text-[#1a1a1a]"
            onClick={() => window.location.reload()}
          >
            {i18n.t('error.boundaryReload')}
          </button>
        </div>
      )
    }
    return this.props.children
  }
}